import { STATE } from "../../thor.const";
import { HttpStatusCode } from "../../thor.enums";
import { exponentialDelay } from "../../utils/http";

class TokenInterceptor {

    public static $inject: string[] = [
        "$injector",
        "$q",
        "authService",
        "configService"
    ];

    constructor(
        $injector: ng.auto.IInjectorService,
        $q: ng.IQService,
        authService,
        configService
    ) {
        const allowed = [
            configService.contentApi.url,
            configService.searchApi.url,
            configService.uploadApi.url,
            configService.statApi.url,
            configService.authApi.url,
            configService.gatewayApi.url,
            configService.thorAuthUrl,
            configService.liveLegacyApi.url,
            configService.paymentApi.url,
            configService.onlineApi.url,
            configService.userApi.url
        ];
        return {
            request(config) {
                const checkAllowed = allowed.some(url => {
                    return config.url.startsWith(url);
                });

                if (!checkAllowed) {
                    return config;
                }

                if (!authService.getRefreshToken()) {
                    authService.removeAccessToken();
                    ($injector.get("$state") as ng.ui.IStateService).go(STATE.V2.LOGIN.name);
                    return config;
                }

                const accessToken = authService.getAccessToken();

                if (accessToken) {
                    config.headers = config.headers || {};
                    config.headers["x-cpm-access-token"] = accessToken;
                    if (!config.headers["x-organization"]) {
                        config.headers["x-organization"] = authService.getOrganizationId();
                    }
                    if (!config.headers["x-cpm-device-id"]) {
                        config.headers["x-cpm-device-id"] = authService.getDeviceId();
                    }
                }

                return config;
            },

            responseError(response) {
                const checkAllowed = allowed.some(url => response.config.url.startsWith(url));
                const throwLogError = res => $injector.get("$log").error("Http response error", res);

                if (!checkAllowed) {
                    throwLogError(response);
                    return $q.reject(response);
                }

                const deferred = $q.defer();
                const retries = 3;

                if (
                    (response.status === HttpStatusCode.ConnectionReset ||
                        response.status >= HttpStatusCode.BadGateway) &&
                    (!response.config?.retry || response.config.retry < retries) &&
                    ["get", "head", "post", "patch"].includes(response.config?.method?.toLowerCase())
                ) {
                    response.config.retry = response.config.retry + 1 || 1;
                    throwLogError(response);
                    $injector.get("$timeout")(
                        () =>
                            $injector
                                .get("$http")(response.config)
                                .then(retryResponse => deferred.resolve(retryResponse))
                                .catch(error => deferred.reject(error)),
                        exponentialDelay(response.config.retry, 400)
                    );
                    return deferred.promise;
                }

                if (response.status === HttpStatusCode.Unauthorized) {
                    throwLogError(response);
                    authService
                        .refreshAccessToken()
                        .then(() =>
                            $injector
                                .get("$http")(response.config)
                                .then(retryResponse => deferred.resolve(retryResponse))
                                .catch(error => deferred.reject(error))
                        )
                        .catch(error => deferred.reject(response));

                    return deferred.promise;
                }

                if (
                    response.status === HttpStatusCode.Forbidden &&
                    (response.data.message === "Signature de session invalide" ||
                        response.data.message === "Access revoked")
                ) {
                    throwLogError(response);
                    authService.removeAccessToken();
                    authService.removeRefreshToken();
                }

                return $q.reject(response);
            }
        };
    }
}

angular
    .module("thor.core.auth.tokenInterceptor", [])
    .factory("tokenInterceptor", TokenInterceptor);
